import React from "react";
import Page, { PageProps } from "../Page";
import { List } from "antd";
import { IRequestsPresenter } from "../../../presenter/request/RequestsPresenter";
import RequestDetailsDialog from "./RequestDetailsDialog";
import { DateService } from "../../../service/DateService";
import Text from "antd/lib/typography/Text";

export interface Props extends PageProps {}
export interface State extends IRequestsPresenter {}

export default class RequestsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  makeBold(read: boolean) {
    if (read) return "normal";
    return "bold";
  }
  formatDate(date: Date) {
    return DateService().formatDate(date);
  }

  render() {
    let {
      translate,
      requests,
      hideRequestsDetailsDialog,
      showRequestsDetailsDialog,
      requestsDetailsDialogVisible,
      rowData,
      markRequestRead,
      setRowData
    } = this.state;

    return (
      <Page {...this.props}>
        <List
          dataSource={requests}
          renderItem={(item, index) => (
            <List.Item
              onClick={(e) => {
                showRequestsDetailsDialog();
                setRowData(item);
                markRequestRead(item);
              }}
              style={{ cursor: "pointer" }}
            >
              <List.Item.Meta
                title={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center"
                    }}
                  >
                    <Text>{`${index + 1}. ${item.name} - ${this.formatDate(
                      item.validFrom
                    )}`}</Text>
                    {!item.read && (
                      <Text
                        style={{
                          color: "#1890ff",
                          marginLeft: 5,
                          backgroundColor: "#f0f0f0",
                          padding: 4,
                          borderRadius: 6,
                          fontSize: 12
                        }}
                      >
                        {translate("applicantRequest_page.new")}
                      </Text>
                    )}
                  </div>
                }
                description={
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        fontSize: 12
                      }}
                    >
                      <Text strong style={{ marginRight: 8 }}>
                        {translate(
                          "applicantRequest_page.reporting_period_name"
                        )}
                      </Text>
                      {item.reportingPeriodName}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        fontSize: 12
                      }}
                    >
                      <Text strong style={{ marginRight: 8 }}>
                        {translate("applicantRequest_page.request_type_name")}
                      </Text>
                      {item.requestTypeName}
                    </div>
                  </div>
                }
                style={{ fontWeight: this.makeBold(item.read) }}
              />
            </List.Item>
          )}
        />
        <RequestDetailsDialog
          translate={translate}
          hideRequestsDetailsDialog={hideRequestsDetailsDialog}
          requestsDetailsDialogVisible={requestsDetailsDialogVisible}
          rowData={rowData}
        />
      </Page>
    );
  }
}
